// "Leave this form?" Asked before anyone leaves a form part-way. Staying is the default.
// Leaving keeps the answers saved on this device unless the family explicitly chooses to clear them.
// Nothing here talks to the server: the copy saved on the server is never touched by these buttons.
import React, { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";

export const LEAVE_TITLE = "Leave this form?";
export const LEAVE_BODY =
  "Your answers are saved on this device, so if you open the same link again you can pick up where you left off. If this is a shared device, you can clear them instead.";

export default function LeaveFormDialog({ open, onStay, onLeaveKeep, onLeaveClear }) {
  const stayRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    if (stayRef.current) stayRef.current.focus();
    const onKey = (e) => {
      if (e.key === "Escape") onStay();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onStay]);

  if (!open) return null;
  return (
    <div className="restore-prompt-overlay leave-overlay" onClick={(e) => { if (e.target === e.currentTarget) onStay(); }}>
      <div
        className="leave-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="leave-title"
        aria-describedby="leave-body"
        data-testid="leave-confirm"
      >
        <h2 id="leave-title" className="leave-title">{LEAVE_TITLE}</h2>
        <p id="leave-body" className="leave-body">{LEAVE_BODY}</p>
        <div className="leave-actions">
          <Button ref={stayRef} onClick={onStay} className="leave-stay" data-testid="leave-stay-btn">
            Stay on the form
          </Button>
          <Button variant="outline" onClick={onLeaveKeep} className="leave-keep" data-testid="leave-keep-btn">
            Leave, keep my answers
          </Button>
        </div>
        <button type="button" onClick={onLeaveClear} className="leave-clear" data-testid="leave-delete-btn">
          Leave and clear my answers from this device
        </button>
      </div>
    </div>
  );
}
